
import actions from './action'
import getters from './getters'
import mutations from './mutation'
import state from './state'
var store = {
	namespaced: true,
	actions,
	getters,
	mutations,
	state
}
export default store



// WEBPACK FOOTER //
// ./src/store/modules/analysis/index.js